module.exports = __webpack_public_path__ + "static/media/logo-white.ce56e6e0.png";